import {Link, LinkProps, useHistory} from "react-router-dom";
import React, {HTMLAttributes, MouseEventHandler} from "react";

type Props = Omit<LinkProps, "onClick"> &
    HTMLAttributes<HTMLAnchorElement> & {
    active: boolean;
    isNative?: boolean;
    replace?: boolean;
};

export function AdaptiveLink (props: Props) {
    const {active, isNative, children, replace = false, ...linkProps} = props;
    const history = useHistory();

    const handleClick: MouseEventHandler<HTMLElement> = (e) => {
        if (active) {
            e.preventDefault()
            props.onClick?.(e);
            return
        }

        if (linkProps.to && !e.shiftKey) {
            e.preventDefault();
            if (replace) {
                history.replace(linkProps.to);
            } else {
                history.push(linkProps.to);
            }
        }

        props.onClick?.(e);
    };

    if (active || isNative) {
        return (
            <div
                onClick={handleClick}
                className={props.className}
            >
                {children}
            </div>
        );
    }

    return (
        <Link replace={replace} {...linkProps}>
            {children}
        </Link>
    );
}